<template>
  <v-navigation-drawer
  v-model="drawer"
  fixed
  right
  width="800px"
  style="z-index: 90"
  temporary
  stateless
  >

    <v-sheet :class="['foreground', {'nav-img-background': $store.state.theme === 'theme1' && $store.state.themeDark}]" style="display: flex; flex-direction: column; height: 100%;">

      <v-row class="align-center c-flex-00a border-b--medium pa-2">
        <v-btn
        icon
        large
        class="ml-2"
        @click="drawer = !drawer"
        >
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
        TIMELINE
        <v-spacer></v-spacer>
        <v-btn
        icon
        large
        class="ml-2"
        @click="componentKey++"
        >
          <v-icon>mdi-reload</v-icon>
        </v-btn>
      </v-row>



      <!-- MAIN SCROLLING AREA -->
      <div style="overflow: auto; flex: 1;">
        <timeline v-if="id" :archive_id="id" :key="componentKey"></timeline>
      </div>
      <!-- MAIN CONTENT -->

    </v-sheet>

  </v-navigation-drawer>
</template>

<script>
import Timeline from '@/components/nav/tracer/views/timeline/Main'

export default {
  components: {
    Timeline
  },
  data () {
    return {
      id: null,
      drawer: false,
      componentKey: 0
    }
  },
  computed: {
  },
  methods: {
    toggle () {
      if (!this.drawer) {
        this.componentKey++
      }
      this.drawer = !this.drawer
    },
    open (id) {
      this.id = id
      this.componentKey++
      this.drawer = true
    }
  },
  created () {
    
  }
}
</script>

<style lang="scss" scoped>
.nav-img-background {
  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.9) 0%, rgba(0, 0, 0, 0.9) 100%), url('https://picsum.photos/1920/1080?random&blur=6');
  background-size: cover;
  background-position: center;
}
</style>